import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { handlePaginationState } from "../../../store/booking/bookingSlice";
import activityApis from "../../../store/activity/activityApis";
import bookingApis from "../../../store/booking/bookingApis";

const mapStateToProps = (state) => {
    return {
        pagination: state.booking.pagination,
    };
};

const mapDispatch = {
    handlePaginationState,

    getActivityList:
        activityApis.endpoints.getActivityList.initiate,

    getBookingList:
        bookingApis.endpoints.getBookingList.initiate,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;